<div *ngIf="items().length" class="mb-3 flex flex-col gap-2">
  <app-notification
    *ngFor="let item of items()"
    class="block rounded-md bg-white overflow-hidden"
    [notification]="item"
    [list]="rowActions">
  </app-notification>
</div>
